import { createIcon } from '@chakra-ui/react'

const IconClose = createIcon({
  displayName: 'IconClose',
  viewBox: '0 0 20 20',
  defaultProps: {
    boxSize: '20px'
  },
  path: (
    <>
      <path
        d="M9.99925 11.0607L15.1258 16.1872L16.1864 15.1265L11.0599 10L16.1864 4.87348L15.1258 3.81282L9.99926 8.93934L4.87273 3.81282L3.81207 4.87348L8.93859 10L3.81207 15.1265L4.87273 16.1872L9.99925 11.0607Z"
        fill="currentColor"
      />
    </>
  )
})

export default IconClose
